import React from 'react';
import GetLocalizedText from './GetLocalizedText';
import TranslateHtml from './TranslateHtml';
import GetCombinedLocalizedText from './GetCombinedLocalizedText';
import i18next from 'i18next';
import Pseudo from 'i18next-pseudo';

export var pseudoInstance = new Pseudo();

export function getLocalizedText(key) {
  return React.createElement(GetLocalizedText, { text: key });
}

export function getTranslatedString(key) {
  return i18next.t(key);
}

export function getCombinedLocalizedText(key, replacementValue) {
  return React.createElement(GetCombinedLocalizedText, { text: key, replacementValue: replacementValue });
}

export function translateHtml(key) {
  return React.createElement(TranslateHtml, { text: key });
}

export function updateLocale(locale) {
  i18next.changeLanguage(locale);
}

export function getLocale() {
  return i18next.language;
}

export function getLanguage() {
  if (i18next.language !== undefined) {
    if (i18next.language.indexOf('-') !== -1) {
      return i18next.language.split('-')[0];
    } else {
      return getLocale();
    }
  }
  return 'en';
}

export function getCountry() {
  if (i18next.language !== undefined && i18next.language.indexOf('-') !== -1) {
    return i18next.language.split('-')[1];
  }
  return 'US';
}

export function configurePseudo(config) {
  pseudoInstance.configurePseudo(config);
}

export function loadResources(resources) {
  Object.keys(resources).forEach(function (key) {
    i18next.addResourceBundle(key, 'translations', resources[key]);
  });
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/wendys-i18next/es/localizationHelpers.js
// module id = 290
// module chunks = 0